import { Button, Col, Form, message, Popconfirm, Radio, Row, Select, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { RadioChangeEvent } from 'antd/lib/radio/interface';
import { OptionProps } from 'antd/lib/select';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { client } from 'src/services/api';

import { Sku } from '../enrollment/Enrollment';

export const SkuListQuery = gql`
  query getSkuList {
    skus {
      id
      name
      desc
    }
  }
`;

const skuListQuery = gql`
  query getSkuListQuery {
    skus {
      id
      name
    }
  }
`;

export interface LimitSku {
  id: string;
  isLimitSku: string;
  skuId: string;
  isLimitOwnedSku: string;
  ownedSkuId: string;
}

interface Props {
  form: WrappedFormUtils;
  activityId: number;
  next: (limitSkuList: LimitSku[]) => void;
  limitSkuList: LimitSku[];
}

interface SkuList {
  skus: Sku[];
}

interface State {
  isLimitSku: boolean;
  limitSkuList: LimitSku[];
  badgeColor: string;
  iconLoading: boolean;
  skus: Sku[];
}

class UserLimitConfig extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLimitSku: false,
      limitSkuList: [
        {
          id: '0',
          isLimitSku: 'named',
          skuId: '',
          isLimitOwnedSku: 'named',
          ownedSkuId: '',
        },
      ],
      badgeColor: '',
      iconLoading: false,
      skus: [],
    };
  }

  async componentWillMount() {
    const { limitSkuList } = this.props;
    this.setState({ limitSkuList });
    const res = await client.query<SkuList>({
      query: skuListQuery,
    });
    const { skus } = res.data;
    this.setState({ skus });
  }

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const { limitSkuList } = this.state;
      const { skuId, ownedSkuId } = values;
      limitSkuList.forEach(limitSku => {
        if (limitSku.isLimitSku === 'named') {
          limitSku.skuId = skuId[limitSku.id];
        }
        if (limitSku.isLimitOwnedSku === 'named') {
          limitSku.ownedSkuId = ownedSkuId[limitSku.id];
        }
      });
      if (err) {
        message.error(err);
        return;
      }
      this.props.next(limitSkuList);
    });
  };

  findTargetIndex = (id: string) => {
    const { limitSkuList } = this.state;
    return limitSkuList.findIndex(limitSku => limitSku.id === id);
  };

  onLimitItemChange = (e: RadioChangeEvent, row: { id: string }) => {
    const { limitSkuList } = this.state;
    const target = this.findTargetIndex(row.id);
    if (target > -1) {
      limitSkuList[target].isLimitSku = e.target.value;
    }
    this.setState({ limitSkuList });
  };

  onLimitOwnedSkuChange = (e: RadioChangeEvent, row: { id: string }) => {
    const { limitSkuList } = this.state;
    const target = this.findTargetIndex(row.id);
    if (target > -1) {
      limitSkuList[target].isLimitOwnedSku = e.target.value;
    }
    this.setState({ limitSkuList });
  };

  addUserConfig = () => {
    const { limitSkuList } = this.state;
    const len = limitSkuList.length - 1;
    const lastId = (limitSkuList[len] && limitSkuList[len].id) || 0;

    limitSkuList.push({
      id: String(Number(lastId) + 1),
      isLimitSku: 'named',
      skuId: '',
      isLimitOwnedSku: 'named',
      ownedSkuId: '',
    });
    this.setState({ limitSkuList });
  };

  cancel = (row: LimitSku) => {
    const { limitSkuList } = this.state;
    const target = this.findTargetIndex(row.id);
    if (target > -1) {
      limitSkuList.splice(target, 1);
    }
    this.setState({ limitSkuList });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { skus, limitSkuList } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    return (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: 30 }}>
        <Table bordered dataSource={limitSkuList} pagination={false} rowKey={row => `${row.id}`}>
          <Table.Column
            key="index"
            render={row => {
              return <span>{row.id}</span>;
            }}
          />
          <Table.Column
            title="sku限制配置"
            align="center"
            key="limitItem"
            render={row => {
              return (
                <>
                  <Row>
                    <Col span={8}>
                      <Form.Item label="sku限制" {...formItemLayout}>
                        <Radio.Group onChange={e => this.onLimitItemChange(e, row)} value={row.isLimitSku}>
                          <Radio value="named">指定某期sku参与活动</Radio>
                          {/* <Radio value="unlimited">不限制</Radio> */}
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      {row.isLimitSku === 'named' && (
                        <Form.Item label="请选择sku" {...formItemLayout}>
                          {getFieldDecorator(`skuId[${row.id}]`, {
                            rules: [
                              {
                                required: true,
                                message: '请选择sku',
                              },
                            ],
                          })(
                            <Select
                              placeholder="请选择活动"
                              showSearch
                              filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
                                return String(option.props.children).indexOf(input) >= 0;
                              }}
                              style={{ width: '100%' }}
                            >
                              {skus.map((sku: { id: number; name: string }) => {
                                return <Select.Option key={`${sku.id}`}>{sku.name}</Select.Option>;
                              })}
                            </Select>,
                          )}
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8}>
                      <Form.Item label="用户限制" {...formItemLayout}>
                        <Radio.Group onChange={e => this.onLimitOwnedSkuChange(e, row)} value={row.isLimitOwnedSku}>
                          <Radio value="named">指定购买过某期的sku用户参与</Radio>
                          {/* <Radio value="unlimited">不限制</Radio> */}
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      {row.isLimitOwnedSku === 'named' && (
                        <Form.Item label="请选择sku" {...formItemLayout}>
                          {getFieldDecorator(`ownedSkuId[${row.id}]`, {
                            rules: [
                              {
                                required: true,
                                message: '请选择sku',
                              },
                            ],
                          })(
                            <Select
                              placeholder="请选择sku"
                              showSearch
                              filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
                                return String(option.props.children).indexOf(input) >= 0;
                              }}
                              style={{ width: '100%' }}
                            >
                              {skus.map((sku: { id: number; name: string }) => {
                                return <Select.Option key={`${sku.id}`}>{sku.name}</Select.Option>;
                              })}
                            </Select>,
                          )}
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                </>
              );
            }}
          />
          <Table.Column
            title="操作"
            align="center"
            key="deleteLimit"
            render={row => {
              return (
                <Popconfirm title="是否确定删除该项配置?" onConfirm={() => this.cancel(row)}>
                  <Button type="primary">删除配置项</Button>
                </Popconfirm>
              );
            }}
          />
        </Table>
        <Button
          style={{ width: '100%', marginTop: 16, marginBottom: 8 }}
          type="dashed"
          icon="plus"
          onClick={this.addUserConfig}
        >
          添加限制配置
        </Button>
        <Row type="flex" justify="end">
          <Button type="primary" htmlType="submit">
            下一步
          </Button>
        </Row>
      </Form>
    );
  }
}

export const UserLimitConfigForm = Form.create({
  mapPropsToFields(props: Props) {
    const formFileds = {};
    props.limitSkuList.forEach(item => {
      formFileds[`skuId[${item.id}]`] = Form.createFormField({ value: item.skuId });
      formFileds[`ownedSkuId[${item.id}]`] = Form.createFormField({ value: item.ownedSkuId });
      formFileds[`isLimitSku[${item.id}]`] = Form.createFormField({ value: item.isLimitSku });
    });
    return formFileds;
  },
})(UserLimitConfig);



// WEBPACK FOOTER //
// ./src/screens/marketing/UserLimitConfig.tsx